import useMapModalStore from '../../../../stores/useMapModalStore';
import useMapViewStore from '../../../../stores/useMapViewStore';
import SalePreviewModal from '../SalePreviewModal';

/**
 * Sale-preview modal (`activeModal === 'salePreview'`).
 *
 * `handleCloseSalePreview` / `handleViewHouseFromSalePreview` used to live in
 * MapCanvas and were prop-drilled through MapModals; both bodies are pure
 * store operations with no other call site, so they moved here verbatim.
 */
export default function SalePreviewHost() {
  const isSalePreviewModalOpen = useMapModalStore((s) => s.activeModal === 'salePreview');
  const salePreviewListing = useMapModalStore((s) => s.payload.salePreviewListing);
  const openModal = useMapModalStore((s) => s.openModal);
  const closeModal = useMapModalStore((s) => s.closeModal);
  const setSalePreviewListing = useMapModalStore((s) => s.setSalePreviewListing);
  const selectedMapObject = useMapViewStore((s) => s.selectedMapObject);

  const handleCloseSalePreview = () => {
    closeModal();
    setSalePreviewListing(null);
  };

  const handleViewHouseFromSalePreview = () => {
    setSalePreviewListing(null);
    openModal('realEstateInfo');
  };

  return (
        <SalePreviewModal
          isOpen={isSalePreviewModalOpen}
          selectedMapObject={selectedMapObject}
          listing={salePreviewListing}
          onClose={handleCloseSalePreview}
          onViewHouse={handleViewHouseFromSalePreview}
        />
  );
}
